<template>
	<div id="main" class="column is-9">
		<Spinner v-if="!idle" size="huge"></Spinner>
		<section class="profile-box" v-if="idle">
			<div class="columns">
				<div class="column">
					<h1>Account Summary</h1>
					<router-link to="/Newpsychic" class="button is-link add-psychic is-small"><i class="fa fa-plus"></i>&nbsp;Psychic</router-link>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<div class="box">
						<article class="media">
							<div class="media-content">
								<div class="content">
									<div class="columns">
										<div class="column">
											<div class="media-left">
												<div class="image is-responsive">
													<img :src="psychicImage" alt="Image" />
												</div>
											</div>
										</div>
										<div class="column">
											<p>
												<h4>{{ psychic.userName }}</h4>
												<span class="psychic-name">{{ psychic.firstName + ` ` + psychic.lastName }}</span><br/>
												<span class="email-add">{{ psychic.email }}</span><br/>
												<span class="phone-num">{{ psychic.phone }}</span><br/>
												<span class="psychic-ext">Psychic ext: {{ psychic.ext }}</span>
										</div>
									</div>
									<div class="columns">
										<div class="column">
											<label class="label">Status</label>
											<div class="field is-maxed">
												<div class="control is-expanded">
													<div class="select is-fullwidth is-small">
														<select v-model="psychic.acctStatus" :disabled="!canEdit">
															<option value="Active">Active</option>
															<option value="Pending">Pending</option>
															<option value="Blacklist">Blacklist</option>
															<option value="Inactive">Inactive</option>
															<option value="Flagged">Flagged</option>
															<option value="Screened">Screened</option>
														</select>
													</div>
												</div>
											</div>
											<label class="label">Permissions</label>
											<div class="field is-narrow permissions">
												<div class="control">
													<label class="checkbox is-small">
													<input type="checkbox" :disabled="!canEdit" name="member" :checked="hasPermission('AgentPhone')" @click="togglePermission('AgentPhone')">Phone</label>
													<label class="checkbox is-small">
													<input type="checkbox" :disabled="!canEdit" name="member" :checked="hasPermission('AgentChat')" @click="togglePermission('AgentChat')">Chat</label>
												</div>
											</div>
										</div>
										<div class="column">
											<label class="label">Availability</label>
											<div class="field has-addons is-maxed">
												<div class="control has-icons-left has-icons-right is-expanded">
													<div class="select is-narrow is-small">
														<select v-model="psychic.status" @change="changeStatus" :disabled="!canEdit">
															<option value="A">Available</option>
															<option value="P">Available (Phone Only)</option>
															<option value="C">Available (Chat Only)</option>
															<option value="O">On Alert</option>
															<option value="U">Unavailable</option>
															<option value="B">Busy</option>
															<option value="R">Reserved</option>
														</select>
													</div>
												</div>
												<div class="control">
													<button class="button is-primary is-small" @click="updateStatus"><i class="fa fa-refresh"></i></button>
												</div>
												<div class="control">
													<button class="button is-info has-tooltip-multiline has-tooltip-left is-small" data-tooltip="Refresh before changing"><i class="fa fa-info"></i></button>
												</div>
											</div>
											<label class="label">Automated Free Minute Emails</label>
											<div class="field is-maxed">
												<div class="control">
													<input type="checkbox" name="member" v-model="psychic.autoEmail">
												</div>
											</div>
										</div>
									</div>
									<ProfileNavigation />
								</div>
							</div>
						</article>
					</div>
				</div>
			</div>
		</section>
		<section class="info-tiles" v-if="idle">
			<div class="columns">
				<div class="column">
					<div class="tile is-ancestor has-text-centered">
						<div class="tile is-parent">
							<article class="tile is-child">
								<div class="tile-header">
									<span class="title">Revenue</span>
								</div>
								<div class="tile-content">
									<p class="subtitle">
										${{ revForPeriod.toLocaleString('en-US') }}<br/>
										<span class="clarifier">Current Period</span>
									</p>
									<router-link :to="'/psychics/' + this.$route.params['id'] + '/readings'" class="button is-small is-primary">Readings</router-link>
								</div>
							</article>
						</div>
						<div class="tile is-parent">
							<article class="tile is-child">
								<div class="tile-header">
									<span class="title">Last Login</span>
								</div>
								<div class="tile-content">
									<p class="subtitle" v-if="!last_login.new">
										{{ formatTimestamp(last_login.login) }} <br/>
										<span class="clarifier" v-if="last_login.new">Duration: {{ formatDuration(this.last_login.duration) }}</span>
									</p>
									<p class="subtitle" v-if="last_login.new">
										Not Recently <br/>
									</p>
									<router-link :to="'/psychics/' + this.$route.params['id'] + '/logins'" class="button is-small is-primary">Readings</router-link>
								</div>
							</article>
						</div>
						<div class="tile is-parent">
							<article class="tile is-child">
								<div class="tile-header">
									<span class="title">Today's Schedule</span>
								</div>
								<div class="tile-content">
									<p class="subtitle"  style="margin-bottom: 0.5em" v-for="(seg, idx) in schedule" :key="idx">
										<span >{{ formatScheduleTime(seg.from) }} - {{ formatScheduleTime(seg.to) }}</span>
									</p>
									<p class="subtitle" v-if="schedule.length == 0">
										Not Available
									</p>
									<router-link :to="'/psychics/' + this.$route.params['id'] + '/schedule'" class="button is-small is-primary">Schedule</router-link>
								</div>
							</article>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="latest-readings" v-if="idle">
			<div class="columns">
				<div class="column">
					<div class="card">
						<header class="card-header">
							<p class="card-header-title">
								Latest Readings
							</p>
						</header>
						<div class="card-table">
							<div class="content">
								<table class="table is-fullwidth is-striped">
									<thead>
										<tr>
											<th>
												Date
											</th>
											<th>
												Member
											</th>
											<th class="is-hidden-mobile">
												Duration
											</th>
											<th class="is-hidden-mobile">
												<abbr title="Minutes">Paid Mins</abbr>
											</th>
											<th>
												<abbr title="Revenue">Rev</abbr>
											</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(reading, idx) in this.readings.slice(0, 5)" :key="idx">
											<td>
												{{ formatTimestamp(reading.date)  }}
											</td>
											<td>
												{{ reading.custUserName }}
											</td>
											<td class="is-hidden-mobile">
												{{ reading.mins }}
											</td>
											<td class="is-hidden-mobile">
												{{ reading.paidMins }}
											</td>
											<td>
												${{ reading.revenue }}
											</td>
										</tr>
									</tbody>
								</table>
								<div class="column has-text-centered">
									<router-link :to="'/psychics/' + this.$route.params['id'] + '/readings'" class="button is-small is-primary">Readings</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<Modal v-if="specialApproval" @close="specialApproval = false">
			<span slot="title">Special Approval Required</span>
			<div slot="body">
				<p class="modal-p">This account requires special approval because it may be linked with other blacklisted accounts. If you would like to deactivate this account, click on Deactivate Now.</p>
				<p class="modal-p" style="margin-top: 15px">Linked Accounts:</p>
				<p class="modal-p" style="margin-top: 15px">
					<ul>
						<li v-for="(username, idx) in dupes" :key="idx">
							{{ username }}
						</li>
					</ul>
				</p>
			</div>
			<div slot="footer" class="field is-grouped">
				<div class="control">
					<a class="button is-light" @click="specialApproval = false">Ok</a>
				</div>
				<div class="control">
					<a class="button is-primary" @click="deactivate()">Deactivate Now</a>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import moment from "moment-timezone"
	import lodash from "lodash"
	import ProfileNavigation from "./ProfileNavigation.vue"
	import Spinner from 'vue-simple-spinner'
    import Modal from "../Modal.vue"

	export default {
		components: {
			ProfileNavigation,
			Spinner,
			Modal
		},
		data() {
			return {
				idle: false,
				psychic: {},
				schedule: [],
				readings: [],
				last_login: {
					new: true,
					login: moment(),
					duration: 0
				},
				specialApproval: false,
				dupes: [],
			}
		},
		watch: {
			'psychic.permissions'(nv, ov) {
				if (ov !== undefined) {
					this.$root.$data.setters.setPermissions(this.$root.$data.state, this.$route.params["id"], this.psychic.permissions)
				}
			},
			'psychic.acctStatus'(nv, ov) {
				if (ov !== undefined) {
					this.$root.$data.setters.setAcctStatus(this.$root.$data.state, this.$route.params["id"], this.psychic.acctStatus)
				}
			},
			'psychic.autoEmail'(nv, ov) {
				if (ov !== undefined) {
					this.$root.$data.setters.setAutoEmail(this.$root.$data.state, this.$route.params["id"], this.psychic.autoEmail)
				}
			}
		},
		methods: {
			togglePermission(perm) {
				if (this.canEdit) {
					let newPerms = []
					let perms = this.psychic.permissions.split(", ")
					if (!perms.includes(perm)) {
						newPerms.push(perm)
					}

					for (let i = 0; i < perms.length; i++) {
						if (perms[i] === perm) {
							continue
						} else {newPerms.push(perms[i])}
					}
			
					this.psychic.permissions = newPerms.join(", ")
				}
			},
			async changeStatus() {
				if (this.canEdit) {
					this.$root.$data.setters.setStatus(this.$root.$data.state, this.$route.params["id"], this.psychic.status)
				}
			},
			async updateStatus() {
				if (this.canEdit) {
					this.psychic.status = await this.$root.$data.getters.getStatus(this.$root.$data.state, this.$route.params["id"])
				}
			},
			async deactivate() {
				this.psychic.acctStatus = 'Blacklist'
				await this.$root.$data.setters.setStatus(this.$root.$data.state, this.$route.params["id"], 'U')
				this.specialApproval = false
			},
			calcRev(reading) {
				return parseFloat(reading.revenue); //reading.paidMins * reading.rate
			},
			hasPermission(name) {
				if (this.psychic.permissions == undefined) { return false }
				return this.psychic.permissions.includes(name)
			},
			formatTimestamp(date) {
				return moment.tz(date, moment.tz.guess(true)).format("MM/DD/YYYY hh:mm A")
			},
			formatDuration(duration) {
				const d = moment.duration(duration, "minutes")
				return `${d.hours()}:${("0" + d.minutes()).slice(-2)}:${("0" + d.seconds()).slice(-2)}`
			},
			formatScheduleTime(time) {
				return moment.tz(time, moment.tz.guess(true)).format("hh:mm A")
			}
		},
		computed: {
			revForPeriod() {
				return  lodash.sumBy(this.readings, (r) => this.calcRev(r))
			},
			psychicImage() {
				if (this.psychic.image === null || this.psychic.image === undefined) {
					return "//cdn.asknow.com/Render/images/hq-psychic-photos/png/default-new.png"
				}
				return `//cn.asknow.com/psychic_images/${this.psychic.image.replace('.meditem', '_436.meditem')}`
			},
			canEdit() {
				return this.psychic.acctStatus !== 'Blacklist' && !(this.psychic.requires_approval && this.psychic.acctStatus == 'Pending')
			}
		},
		async created() {
			const startDate = this.$root.$data.state.payStart.valueOf().toString()
			const endDate = this.$root.$data.state.payEnd.valueOf().toString()

			const psychicResult = await this.$root.$data.getters.getPsychic(this.$root.$data.state, this.$route.params["id"])
			const readingsResult = await this.$root.$data.getters.getReadings(this.$root.$data.state, this.$route.params["id"], startDate, endDate)
			const loginsResult = await this.$root.$data.getters.getLogins(this.$root.$data.state, this.$route.params["id"])
			this.schedule = await this.$root.$data.getters.getSchedule(this.$root.$data.state, this.$route.params["id"])
			this.schedule = this.schedule.filter((s) => s.day - 1 == moment().day()).sort((a, b) => a.number > b.number)

			this.psychic = psychicResult
			this.readings = readingsResult.readings.sort((a, b)  => a["date"] < b["date"])
			if (loginsResult.length > 0) {
				this.last_login = loginsResult[0]
			}

			if(this.psychic.requires_approval && this.psychic.acctStatus === 'Pending') {
				this.dupes = await this.$root.$data.getters.getDupes(this.$root.$data.state, this.$route.params["id"])
				this.specialApproval = true
			}

			this.idle = true
		}
	}
</script>